import { useQuery } from '@tanstack/react-query';
import { allocationQueries } from '../queries';
import type { AllocationBody } from '../types/Allocation';

/**
 * Pré-checagem (`POST /allocations/validation`, `04-spec-api-back.md` §4.4) —
 * `body` é `null` enquanto os campos mínimos (profissional, projeto, início)
 * não estão preenchidos; o debounce de 400ms mora no `queryFn` (`queries.ts`).
 */
export function useValidateAllocation(body: (AllocationBody & { id?: number }) | null) {
  return useQuery(allocationQueries.validation(body));
}
